
define('ldsh!modules/page_generator/templates/preview', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-preview-header"></div>\n<div class="ed-preview-content js-preview-content">\n  <div class="ed-preview-scroll">\n    <div class="ed-embed-container js-preview">\n    </div>\n  </div>\n</div>\n<div class="ed-preview-footer"></div>';

}
return __p
};});

